// Entity, attributes, relationships aren't typed, so we don't have nice way to read values,
// this file is intended to export some getter methods for Entity and its relationships

export const getRelationshipId = (entity, name) =>
  entity?.relationships?.[name]?.data.id;

export const getRelationshipIds = (entity, name) => {
  const dataArray = entity?.relationships?.[name]?.data || [];
  return dataArray.map(item => item.id);
};

export const getEntitiesFromMap = (entityIds, entityMap) => {
  const entities = [];
  entityIds.forEach(id => {
    const entity = entityMap[id];
    if (entity) {
      entities.push(entity);
    }
  });

  return entities;
};
